program Project1;

uses
  Vcl.Forms,
  WEBLib.Forms,
  uMenu in 'uMenu.pas'{*.html},
  uDocEntrena in 'uDocEntrena.pas',
  uDocAsigna in 'uDocAsigna.pas'{*.html},
  uDocGenAsigna in 'uDocGenAsigna.pas'{*.html},
  uRegEntEmp in 'uRegEntEmp.pas'{*.html},
  uSolicitudDwk in 'uSolicitudDwk.pas'{*.html},
  uCerrarSolicitud in 'uCerrarSolicitud.pas'{*.html},
  uUsuarios in 'uUsuarios.pas'{*.html},
  uArchivoDWK in 'uArchivoDWK.pas'{*.html},
  uMenuReportes in 'uMenuReportes.pas'{*.html},
  uRep1 in 'uRep1.pas'{*.html},
  uRepEntEmp in 'uRepEntEmp.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TFMenu, FMenu);
  Application.CreateForm(TFDocEntrena, FDocEntrena);
  Application.CreateForm(TFDocAsigna, FDocAsigna);
  Application.CreateForm(TFDocGenAsigna, FDocGenAsigna);
  Application.CreateForm(TFRegEntEmp, FRegEntEmp);
  Application.CreateForm(TFSolicitudDwk, FSolicitudDwk);
  Application.CreateForm(TFCerrarSolicitud, FCerrarSolicitud);
  Application.CreateForm(TFUsuarios, FUsuarios);
  Application.CreateForm(TFArchivoDWK, FArchivoDWK);
  Application.CreateForm(TFMenuReportes, FMenuReportes);
  Application.CreateForm(TFRep1, FRep1);
  Application.CreateForm(TFRepEntEmp, FRepEntEmp);
  Application.Run;
end.
